import RfiGrantFileAccessModal from './RfiGrantFileAccessModal.component';

export default RfiGrantFileAccessModal;
